import { useTranslations } from 'next-intl';
import React from 'react';
import { CalendarEvent } from '@wwe-portal/entities/calendar.type';
import { formatDateTime } from '@wwe-portal/utils/date';

function CalendarEventItem({ event }: Readonly<{ event: CalendarEvent }>) {
  const t = useTranslations();
  const formatDate = "DDD 'at' t";
  const startDateTime = event.startDate
    ? formatDateTime(event.startDate, formatDate)
    : '';
  const endDateTime = event.endDate
    ? formatDateTime(event.endDate, formatDate)
    : '';

  return (
    <div className="bg-back400 flex w-full flex-col justify-between gap-5 rounded-[10px] px-[30px] py-[10px] md:flex-row md:gap-0 xl:py-[19px]">
      <div className="flex basis-1/2 flex-col md:basis-2/3 md:justify-between xl:flex-row">
        <p className="m-0 flex-1 justify-self-start text-xs">{startDateTime}</p>
        <p className="text-text500 m-0 flex-1 justify-self-start text-xs">
          {event.name}
        </p>
      </div>

      <p className="text-text500 m-0 flex w-full justify-start text-xs md:flex-1 md:basis-1/3 md:justify-end">
        {`${t('ends_on')} ${endDateTime}`}
      </p>
    </div>
  );
}

export default CalendarEventItem;
